import type { ConsentStatus, RequirableScope } from "@/core/consent/domain/consent.types";

export const isResolved = (state: ConsentStatus): boolean => state.status === "resolved";

/**
 * Whether the visitor has consented to `scope`. `false` while unresolved for
 * every decidable scope: before a decision exists, "no consent" and "declined"
 * must be indistinguishable to anything acting on the answer — a grant can
 * only ever come from a real decision.
 */
export const hasConsent = (state: ConsentStatus, scope: RequirableScope): boolean => {
  if (scope === "necessary") {
    return true;
  }

  return state.status === "resolved" && state.decision[scope] === true;
};
